"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const constants_1 = require("./theme/constants");
exports.AppStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column;
  align-items: stretch;
  justify-content: stretch;
  min-height: 100vh;
  background-color: ${design_system_1.theme.colors.marine[5]};
  color: ${design_system_1.theme.colors.marine[100]};
  font-size: min(1em, 4vw);

  > section {
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    justify-content: start;
    max-width: 77em;
    margin: 0 auto;
    padding: 1.5em 1em 1em;

    @media (min-width: ${constants_1.sizes.tablet}) {
      min-width: 50em;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      min-width: fit-content;
    }

    @media (max-width: ${constants_1.sizes.mobile}) {
      min-width: fit-content;
    }
  }
}
`;
//# sourceMappingURL=app.styled.js.map